export const getSecondaryColor = () => {
  return '#faad4d';
};

export const getSecondaryColorNumbers = () => {
  const color = getSecondaryColor();
  const matches = color.match(/#([\da-f]{2})([\da-f]{2})([\da-f]{2})/i);
  return matches.slice(1).map((number) => parseInt(number, 16));
};
